import { AxiosError } from "axios";

import NetworkErrorModel from "../models/api/NetworkErrorModel";
import ServerErrorModel from "../models/api/ServerErrorModel";
import ServerForbiddenErrorModel from "../models/api/ServerForbiddenErrorModel";
import ServerNotFoundErrorModel from "../models/api/ServerNotFoundErrorModel";
import ServerUnauthorizedErrorModel from "../models/api/ServerUnauthorizedErrorModel";
import ServerValidationErrorModel from "../models/api/ServerValidationErrorModel";
import { ProblemDetailsHelper } from "./problemDetails";

export class ApiHelper {
  /** Parses AxiosError and returns prepared error model. */
  public static getApiError(
    error: AxiosError,
  ):
    | AxiosError
    | NetworkErrorModel
    | ServerValidationErrorModel
    | ServerUnauthorizedErrorModel
    | ServerForbiddenErrorModel
    | ServerNotFoundErrorModel
    | ServerErrorModel {
    const response = error.response;

    if (error?.message === "Network Error") {
      // todo: toast network error message?
      return new NetworkErrorModel(error, "Network error occurred.");
    }

    if (response) {
      const status = response.status;
      const problemDetails = ProblemDetailsHelper.getProblemDetailsFromError(error);
      const isProblemDetails = ProblemDetailsHelper.isProblemDetails(problemDetails);

      if (status === 400) {
        return new ServerValidationErrorModel(
          response,
          problemDetails?.detail || "Validation error occurred.",
          isProblemDetails ? problemDetails : { title: "Validation error occurred." },
        );
      } else if (status === 401) {
        return new ServerUnauthorizedErrorModel(
          response,
          "Unauthorized error occurred.",
          isProblemDetails ? problemDetails : { title: "Unauthorized error occurred." },
        );
      } else if (status === 403) {
        return new ServerForbiddenErrorModel(
          response,
          "Forbidden error occurred.",
          isProblemDetails ? problemDetails : { title: "Forbidden error occurred." },
        );
      } else if (status === 404) {
        return new ServerNotFoundErrorModel(
          response,
          "Not found error occurred.",
          isProblemDetails ? problemDetails : { title: "Not found error occurred." },
        );
      } else if (status === 500) {
        return new ServerErrorModel(
          response,
          "Server side error occurred.",
          isProblemDetails ? problemDetails : { title: "Server side error occurred." },
        );
      } else {
        // if unknown error, just rethrow and do not wrap
        return error;
      }
    }
    return error;
  }
}
